export default (filename) => /\.(mp4|ogv|webm)$/.test(filename);
